import React, { useEffect, useMemo } from 'react';
import { Layout, ConfigProvider } from 'antd';
import { getTheme, useTheme } from '../../resources/theme';
import ContentLayout from './layout/content-layout';
import FooterLayout from './layout/footer-layout';
import { loginLineRequest } from '../../redux/line/action';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCustomer } from '../../screens/hooks/useGetCustomer';
import { setCookies } from '../../store/useCookies';
import { setInfo } from '../../redux/info/action';
import HeaderLayout from './layout/header-layout';
import {
  FULLSCREEN_ROUTES,
  ROUTES_PATH,
  WITH_MENU_SCEEN_ROUTES,
  WITHOUT_MENUSCEEN_ROUTES,
} from '../../resources/routes-name';

const useIsFullScreenRoute = (pathname = '') => {
  return useMemo(() => {
    if (!pathname) return false;
    const currentRoute = Object.values(ROUTES_PATH).find((route) => route.PATH === pathname);
    return Boolean(currentRoute && FULLSCREEN_ROUTES.includes(currentRoute.KEY));
  }, [pathname]);
};
const useIsWithMenuOutScreenRoute = (pathname = '') => {
  return useMemo(() => {
    if (!pathname) return false;
    const currentRoute = Object.values(ROUTES_PATH).find((route) => route.PATH === pathname);
    return Boolean(currentRoute && WITHOUT_MENUSCEEN_ROUTES.includes(currentRoute.KEY));
  }, [pathname]);
};
const useIsWithMenuScreenRoute = (pathname = '') => {
  return useMemo(() => {
    if (!pathname) return false;
    const currentRoute = Object.values(ROUTES_PATH).find((route) => route.PATH === pathname);
    return Boolean(currentRoute && WITH_MENU_SCEEN_ROUTES.includes(currentRoute.KEY));
  }, [pathname]);
};
const LayoutPage = () => {
  const { globalTheme, sidebarMode } = useTheme();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state?.line?.profile) || {};
  const isFullScreenRoute = useIsFullScreenRoute(location.pathname);
  const isWithOutScreenRoute = useIsWithMenuOutScreenRoute(location.pathname);
  const IsWithMenuScreenRoute = useIsWithMenuScreenRoute(location.pathname);

  const { mutate: onCallInfo } = useGetCustomer();

  useEffect(() => {
    if (!profile.userId) dispatch(loginLineRequest());
  }, [dispatch, profile?.userId]);

  useEffect(() => {
    if (profile?.userId) {
      onCallInfo(
        { userId: profile.userId },
        {
          onSuccess: (info) => {
            dispatch(setInfo(info?.result?.item));
            setCookies('accessToken', info?.result?.item?.accessToken);
          },
        },
      );
    }
  }, [dispatch, profile, onCallInfo]);

  return (
    <ConfigProvider theme={globalTheme}>
      <Layout
        className="site-layout"
        style={{
          height: '100vh',
        }}
      >
        {!isFullScreenRoute && <HeaderLayout />}
        <ContentLayout
          getTheme={getTheme}
          sidebarMode={sidebarMode}
          isFullScreenRoute={isFullScreenRoute}
          isWithOutScreenRoute={isWithOutScreenRoute}
          IsWithMenuScreenRoute={IsWithMenuScreenRoute}
        />
        <FooterLayout />
      </Layout>
    </ConfigProvider>
  );
};

export default LayoutPage;
